// extracted by mini-css-extract-plugin
export var container = "layout-module--container--992be";
export var footer = "layout-module--footer--2d985";